import React from 'react'
import { Carousel, Ratio } from 'react-bootstrap'
import nextIcon from './carousel-next.png'
import prevIcon from './carousel-prev.png'

const SliderSlide = ({ slide }) => {
  switch(slide.type) {
    case "image":
      return (
        <Ratio aspectRatio="16x9">
          <img src={slide.url} className="img-fluid" />
        </Ratio>
      )
    case "video":
      return (
        <Ratio aspectRatio="16x9">
          <iframe
            allowFullScreen="0" 
            frameBorder="0"
            src={`//www.youtube.com/embed/${slide.videoId}?rel=0&controls=1&showinfo=0`}
          />
        </Ratio>
      )
    default:
      return null
  }
}

const Slider = ({ slides }) => {
  if(slides.length === 0) {
    return null
  }
  else if(slides.length === 1) {
    return <SliderSlide slide={slides[0]} />
  }
  else {
    return (
      <Carousel
        nextIcon={<img src={nextIcon} style={styles.icon} />}
        prevIcon={<img src={prevIcon} style={styles.icon} />}
      >
        { slides.map((slide, index) =>
        <Carousel.Item key={index}>
          <SliderSlide slide={slide} />
        </Carousel.Item>
        )}
      </Carousel>
    )
  }
}

const styles = {
  icon: {
    height: 50,
    width: "auto"
  }
}

export default Slider
